import { SUPPORT_LINES } from "../../utils";
import useFetch from "../hooks/useFetch";

export const useGetSupportPhoneNumber = (
  kind = SUPPORT_LINES.CANCELLATION,
) => useFetch(`customer_service_phones/${kind}`, { shadow: true });
